'use client';

import { FC, useCallback } from 'react';
import { useRouter } from 'next/navigation'

import { Button } from 'components/ui/button';
import { OWNER_ROUTES } from 'utils/routes';
import { useJoinCommunityTracking } from 'app/_tracking/events';

interface IJoinButton {
  title?: string;
  location: 'cta' | 'header';
  isPreview?: boolean;
}

export const JoinButton: FC<IJoinButton> = ({ title, location, isPreview }) => {
  const router = useRouter();
  const { trackJoinCommunity } = useJoinCommunityTracking();

  const handleClick = useCallback(() => {
    trackJoinCommunity(location);

    router.push(OWNER_ROUTES.APPLY.getPath());
  }, [location, router, trackJoinCommunity]);

  return (
    <Button variant="white" size="lg" className="px-10" onClick={isPreview ? () => void 0 : handleClick}>
      {title ? title : 'Join'}
    </Button>
  );
};
